import { useQuery } from 'react-query';
import axios from 'axios';

import { useAppSelector } from '@/app/hooks';
import { Workspace, WorkspaceById } from '@/models/WorkspacesByTenant';
import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { selectCurrentWorkspace } from '@/modules/Dashboard/Workspaces/workspaceSlice';
import { AwsConfigApiGateway } from '@/utils/config/api';

import queryKeys from '../../modules/shared/query/queryKeys';

async function getWorkspaceById(token: string | undefined, workspaceId: string) {
  const response = await axios.get<WorkspaceById>(
    `${AwsConfigApiGateway.pooledTenantApiUrl}/workspaces/${workspaceId}`,
    {
      headers: {
        'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
        Authorization: 'Bearer ' + token,
      },
    },
  );
  return response.data.data;
}

export function useGetWorkspacesById() {
  const { user } = useAuth();
  const workspace = useAppSelector(selectCurrentWorkspace);
  return useQuery<Workspace>({
    queryKey: [queryKeys.workspace, workspace?.id],
    queryFn: () => getWorkspaceById(user?.signInUserSession?.idToken.jwtToken, workspace?.id ?? ''),
    enabled: !!workspace?.id && !!user?.signInUserSession?.idToken.jwtToken,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
